import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageTitle from "../../../components/partials/PageTitle";
import {
  getAllWorkflow,
  resetSingleWorkflow,
} from "../../../redux/slice/workflow/workflowSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import moment from "moment";
import { BsArrowRight } from "react-icons/bs";
import { LoaderTwo } from "./../../../components/loader/LoaderTwo";

const Workflow = () => {
  const { workflowData } = useSelector((state) => state.workflow);
  const data = workflowData?.get_work_flow?.slice().reverse();

  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const [hasCreateWorkflow, setHasCreateWorkflow] = useState(null)
  const [hasViewWorkflow, setHasViewWorkflow] = useState(null)

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const breadcrumb = {
    from: {
      title: "Workflow",
      link: "/admin/workflow",
    },
    current: {
      title: "Workflow",
      link: null,
    },
  };

  useEffect(() => {
    dispatch(resetSingleWorkflow());
    dispatch(getAllWorkflow());
  }, []);

  useEffect(() => {
    if (!user_permissions?.some(permission => permission.name === 'workflow module')) {
      navigate('/admin/dashboard')
    }

    setHasCreateWorkflow(user_permissions?.some(permission => permission.name === 'create workflow'))
    setHasViewWorkflow(user_permissions?.some(permission => permission.name === 'view workflow'))
  }, [navigate, user_permissions])

  if (!workflowData) {
    return (
      <div className='mt-3'>
        <LoaderTwo />
      </div>
    );
  }

  
  return (
    <>
      {/* page title */}
      <PageTitle title='Workflow Process' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card '>
            <div className='card-body'>
              <div className='border border-1 rounded-1 p-2'>
                {hasCreateWorkflow && <Link
                  to='/admin/workflow/create'
                  className='btn btn-sm btn-primary'
                >
                  + Create Workflow
                </Link>}
                <div className='table-responsive mt-4'>
                  <table className='table table-centered table-striped nowrap w-100 no-footer'>
                    <thead>
                      <tr>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "220.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Name
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "500.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Roles
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "144.8px" }}
                          aria-label='Phone: activate to sort column ascending'
                        >
                          Date Created
                        </th>
                        {hasViewWorkflow && <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "86.8px" }}
                        >
                          Action
                        </th>}
                      </tr>
                    </thead>

                    <tbody>
                      {data?.map((workflow, i) => (
                        <tr key={i}>
                          <td>{workflow?.work_flow_name}</td>
                          <td>
                            <div className='d-flex d-col flex-wrap'>
                              {JSON.parse(workflow?.target_role)?.map(
                                (item, index) => (
                                  <div
                                    className='d-flex d-col align-items-center'
                                    key={index + "inner"}
                                  >
                                    <span
                                      className='py-1 px-2 bg-info text-white'
                                      style={{ marginTop: "2px" }}
                                    >
                                      {item.role_name}
                                    </span>
                                    {JSON.parse(workflow?.target_role)
                                      ?.length !==
                                      index + 1 &&
                                      JSON.parse(workflow?.target_role)
                                        ?.length !== 1 && (
                                        <BsArrowRight className='m-0 md-rotate-90' />
                                      )}
                                  </div>
                                )
                              )}
                            </div>
                          </td>
                          <td>
                            {moment(workflow?.created_at).format("D/M/Y")}
                          </td>
                          {hasViewWorkflow && <td>
                            <Link to={`/admin/workflow/view/${workflow?.id}`}>
                              <i className='mdi mdi-eye fs-4 text-primary'></i>
                            </Link>
                          </td>}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* <div className='row mt-2'>
                <div className='col-sm-12 col-md-6'>
                  <div
                    className='dataTables_info table-pages'
                    id='products-datatable_info'
                    role='status'
                    aria-live='polite'
                  >
                    Showing policies {policyConfig?.policy?.from} to{" "}
                    {policyConfig?.policy?.to} of {policyConfig?.policy?.total}
                  </div>
                </div>
                <div className='col-sm-12 col-md-6'>
                  <PaginationLinks
                    paginationData={policyConfig?.policy}
                    getNextPage={fetchStaffsHandler}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Workflow;
